<template>
  <PrincipalWorkspace
    :inline="true"
    :principal="workspacePrincipal"
    :authLevel="authLevel"
    :cat="cat"
    :client-name="clientName"
    :display-type="displayType"
    :policy="policy"
    :server-date="serverDate"
    @close="handleCloseWorkspace"
    @reset="handleWorkspaceReset"
    v-if="workspacePrincipal"
  />

  <template v-else>
    <div
      class="card z-depth-0 principal-card"
      :class="{
        white: displayType == 'a',
        'yellow lighten-5': displayType == 'h',
        'orange lighten-5 principal-card-orphan': displayType == 'o',
      }"
      v-for="enrollee in enrollees"
      :key="enrollee.id"
      @click="handleOpenWorkspace(enrollee)"
    >
      <div class="card-content z-depth-0">
        <div class="row valign-wrapper">
          <div class="col s3 m2">
            <img
              :src="enrollee.profile_img"
              width="96"
              class="circle responsive-img left"
              v-if="enrollee.profile_img"
            />
            <img
              :src="`https://ui-avatars.com/api/?name=${enrollee.name}&color=FFFFFF&size=128`"
              width="96"
              class="circle responsive-img left"
              v-else
            />
          </div>

          <div class="col s7 m7">
            <p class="grey-text text-darken-1 enrollee-number">{{ enrollee.enrollee_number }}</p>
            <h5>
              {{ enrollee.name }}
              <sup>
                <small>
                  <span class="black-text">{{ showAgeSex(enrollee.dob, enrollee.sex) }}</span>
                </small>
              </sup>
            </h5>
            <small class="grey-text text-darken-1" v-if="enrollee.provider">
              {{ enrollee.provider.name }}
            </small>
          </div>

          <div class="col s2 m3 right-align">
            <i
              class="material-icons plan-icon"
              :class="{ 'teal-text': enrollee.type == 'f', 'blue-grey-text': enrollee.type != 'f' }"
            >
              {{ enrollee.type == "f" ? "groups" : "person" }}
            </i>
            <div class="plan-meta hide-on-small-only">
              <strong>{{ enrollee.type == "f" ? "Family" : "Individual" }}</strong>
              <small>{{ enrollee.plan?.name || "No plan" }}</small>
              <small v-if="enrollee.type == 'f'">
                {{ enrollee.spouse ? "Spouse" : "No spouse" }} |
                {{ enrollee.dependants?.length || 0 }} dependant(s)
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { ref } from "vue";
import { ageSex } from "@/composables/fxLibrary/coreFx";
import PrincipalWorkspace from "@/components/client/extras/PrincipalWorkspaceClientComponent.vue";

export default {
  name: "PrincipalActiveHoldClientComponent",
  components: {
    PrincipalWorkspace,
  },
  props: ["cat", "authLevel", "clientName", "enrollees", "displayType", "policy", "serverDate"],
  emits: ["reset", "detail-state"],
  setup(props, context) {
    const workspacePrincipal = ref(null);
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    const handleOpenWorkspace = (principal) => {
      if (props.displayType == "o") {
        return;
      }

      workspacePrincipal.value = principal;
      context.emit("detail-state", true);
    };

    const handleCloseWorkspace = () => {
      workspacePrincipal.value = null;
      context.emit("detail-state", false);
    };

    const handleWorkspaceReset = (principal) => {
      if (!principal) {
        return;
      }

      workspacePrincipal.value = principal;
      context.emit("reset", principal);
    };

    return {
      handleCloseWorkspace,
      handleOpenWorkspace,
      handleWorkspaceReset,
      showAgeSex,
      workspacePrincipal,
    };
  },
};
</script>

<style scoped>
.principal-card {
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.principal-card:hover,
.principal-card:focus-within {
  background-color: #f5fbfb !important;
  border-color: #b2dfdb;
  transform: translateY(-1px);
}

.principal-card-orphan {
  border-color: #ffcc80;
  cursor: default;
}

.principal-card-orphan:hover,
.principal-card-orphan:focus-within {
  background-color: #fff3e0 !important;
  border-color: #ffcc80;
  transform: none;
}

.principal-card h5 {
  margin-bottom: 4px;
  margin-top: 4px;
}

.enrollee-number {
  margin: 0;
}

.plan-icon {
  display: block;
  font-size: 34px;
  margin-bottom: 4px;
}

.plan-meta {
  display: grid;
  gap: 2px;
}

.plan-meta small,
.plan-meta strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
